module.exports = __webpack_public_path__ + "media/St 4-keyboard-question.ff93433f.wav";